import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { MessageSquareText, RotateCcw, Save } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { useMessageTemplates } from '../lib/messageTemplates';
import { RUNTIME_BACKEND_URL } from '../lib/backendUrl';

// Ayarlar sayfası: kullanıcının kendi WhatsApp/SMS mesaj şablonları
export const MessageTemplatesCard = ({ path, token, defaults }) => {
  const { custom, setCustom } = useMessageTemplates(path, token, defaults);
  const [draft, setDraft] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setDraft(Object.fromEntries(defaults.map(t => [t.key, custom[t.key] || t.text]))); }, [custom, defaults]);

  const save = async () => {
    setSaving(true);
    try {
      const body = Object.fromEntries(Object.entries(draft).filter(([k, v]) => v !== defaults.find(t => t.key === k)?.text));
      const r = await fetch(`${RUNTIME_BACKEND_URL}${path}/message-templates`, {
        method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify(body),
      });
      if (!r.ok) throw new Error();
      setCustom(await r.json());
      toast.success('Mesaj şablonları kaydedildi');
    } catch { toast.error('Kaydedilemedi'); }
    finally { setSaving(false); }
  };

  return (
    <Card data-testid="message-templates-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><MessageSquareText className="h-4 w-4" /> Mesaj Şablonları (WhatsApp / SMS)</CardTitle>
        <p className="text-xs text-muted-foreground">Süslü parantezli alanlar otomatik doldurulur. Değiştirmediğiniz şablon varsayılan olarak kalır.</p>
      </CardHeader>
      <CardContent className="space-y-4">
        {defaults.map(t => (
          <div key={t.key} className="space-y-1.5" data-testid={`template-${t.key}`}>
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-medium">{t.label}</p>
              {draft[t.key] !== t.text && (
                <button type="button" onClick={() => setDraft(d => ({ ...d, [t.key]: t.text }))} className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid={`template-reset-${t.key}`}>
                  <RotateCcw className="h-3 w-3" /> Varsayılan
                </button>
              )}
            </div>
            <Textarea rows={3} value={draft[t.key] || ''} onChange={e => setDraft(d => ({ ...d, [t.key]: e.target.value }))} data-testid={`template-input-${t.key}`} />
            <div className="flex flex-wrap gap-1">
              {t.vars.map(v => (
                <button key={v} type="button" onClick={() => setDraft(d => ({ ...d, [t.key]: `${d[t.key] || ''} {${v}}` }))}
                  className="text-[10px] px-1.5 py-0.5 rounded bg-muted hover:bg-muted/70 font-mono">{`{${v}}`}</button>
              ))}
            </div>
          </div>
        ))}
        <Button onClick={save} disabled={saving} size="sm" data-testid="templates-save-btn"><Save className="h-3.5 w-3.5 mr-1.5" /> Şablonları Kaydet</Button>
      </CardContent>
    </Card>
  );
};
